import { render, staticRenderFns } from "./RemovalReportTab.vue?vue&type=template&id=2e1d542a"
import script from "./RemovalReportTab.vue?vue&type=script&lang=js"
export * from "./RemovalReportTab.vue?vue&type=script&lang=js"
import style0 from "./RemovalReportTab.vue?vue&type=style&index=0&id=2e1d542a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports